/**
 * Help is the component that pops up and shows us a particular help screen
 */
import { writable } from "svelte/store"
import type { HelpDocPaths } from "virtual:documentation"

const helpPathAliases = new Map<string, HelpDocPaths>([
    ["audiobook", "listening"],
    ["notetaking", "taking-notes"],
])

function normalizeHelpPath(index: HelpDocPaths | string) {
    const [page, id] = index.split("#")
    const normalizedPage = helpPathAliases.get(page) ?? page
    return { page: normalizedPage, id }
}

/**
 * Opens help to a specific place
 */
export async function openHelp(index?: HelpDocPaths | string) {
    _open.set(true)
    if (!index) {
        _location.set(null)
        return
    }
    _location.set(normalizeHelpPath(index))
}

export function closeHelp() {
    _open.set(false)
}

export const _location = writable<{ page: string; id: string } | null>(null)
export const _open = writable(false)
